import { usdFormat } from "../../../../utils";
import { DiscountsReportRow } from "./type";
import { ColDef } from "ag-grid-community";

const generateColDefs = (): ColDef<DiscountsReportRow>[] => [
  {
    headerName: "Discount Name",
    field: "discount_name",
    filter: "agTextColumnFilter",
    cellStyle: params =>
        params.data?.discount_name === "Total" || params.data?.isTotal
            ? { fontWeight: "bold" }
            : null,
    pinned: "left",
  },
  {
    headerName: "Applied Discount Amount",
    field: "discount_value", // cents
    valueFormatter: params =>
        usdFormat.format(((params.value ?? 0) as number) / 100),
    filter: "agNumberColumnFilter",
    cellStyle: params =>
        params.data?.discount_name === "Total" || params.data?.isTotal
            ? { fontWeight: "bold" }
            : null,
  },
  {
    headerName: "Count",
    field: "discount_count",
    filter: "agNumberColumnFilter",
    cellStyle: params =>
        params.data?.discount_name === "Total" || params.data?.isTotal
            ? { fontWeight: "bold" }
            : null,
  },
];

export const colDefs: ColDef<DiscountsReportRow>[] = generateColDefs();

export const formatData = (rows: DiscountsReportRow[]) => {
  if (!rows?.length) return [];

  // Group rows by discount name (adjust key to split by type if desired)
  const grouped: Record<string, DiscountsReportRow> = {};

  // Running totals for the Total row
  const totalRow: DiscountsReportRow = {
    discount_name: "Total",
    discount_value: 0,
    discount_count: 0,
    isTotal: true,
    // keep other props optional/empty
    username: "",
    location_name: "",
    location_id: 0,
  } as DiscountsReportRow;

  for (const r of rows) {
    const name = r.discount_name ?? "Unknown";
    // To separate by type as well, use: const key = `${name}::${r.discount_type ?? ""}`;
    const key = name;

    const value = r.discount_value ?? 0;   // cents
    const count = r.discount_count ?? 0;

    if (!grouped[key]) {
      grouped[key] = {
        ...r,
        discount_name: name,
        discount_value: value,
        discount_count: count,
        isTotal: false,
      };
    } else {
      grouped[key].discount_value += value;
      grouped[key].discount_count += count;
    }

    // Accumulate into total row
    totalRow.discount_value += value;
    totalRow.discount_count += count;
  }

  const result = Object.values(grouped);

  // Append Total row (last)
  result.push(totalRow);

  return result;
};
